module.exports={common:{app_name:"Espoo Digital Reception",app_organization:"City of Espoo"}};